module.exports = new __parcel__URL__("7557.3c8b271b.png").toString();